import React from "react";
import { DragHandle } from "./DragHandle";
import styled from "styled-components";
import { TableRow, TableCell } from "@material-ui/core";
const StyledStaticData = styled.td`
  background: white;
  &:first-of-type {
    min-width: 20ch;
  }
`;

const StyledStaticTableRow = styled.tr`
  box-shadow: rgb(0 0 0 / 10%) 0px 20px 25px -5px,
    rgb(0 0 0 / 30%) 0px 10px 10px -5px;
  outline: #3e1eb3 solid 1px;
`;

const StaticTableRow = ({ row }) => {
  const { key: rowKey, ...rowProps } = row.getRowProps();
  return (
    <TableRow key={rowKey} {...rowProps} style={{ backgroundColor: "#fff" }}>
      {row.cells.map((cell, i) => {
        const { key: cellKey, ...cellProps } = cell.getCellProps();
        if (i === 0) {
          return (
            <TableCell key={cellKey} className="dataCell" style={{ width: "24px" }} {...cellProps}>
              <DragHandle isDragging />
              <span>{cell.render("Cell")}</span>
            </TableCell>
          );
        }
        
        const columnId = cell.column.id;
        
        return (
          <TableCell
            key={cellKey}
            align={cell.column.align || "center"}
            className="dataCell"
            {...cellProps}
          >
            {columnId === "charges" ? (
              "-"
            ) : columnId === "action" || columnId === "legRiskSettings" ? (
              null
            ) : (
              cell.render("Cell")
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
export default StaticTableRow